import React from 'react';
const CartHeaderLoader = () => <div className="flex justify-between items-center w-full px-5 md:px-7 py-6 border-b border-neutral-100 dark:border-neutral-800" data-sentry-component="CartHeaderLoader" data-sentry-source-file="cart-header-loader.tsx">
    <div className="h-6 bg-neutral-300 dark:bg-neutral-600 rounded w-1/3" />
    <div className="h-8 w-8 bg-neutral-300 dark:bg-neutral-600 rounded-full" />
  </div>;
export default CartHeaderLoader;